import React from 'react';
import '../../styles/c_HomeSectionIntroduction.css';
import { useHomeData } from '../../hooks/useHomeData';

function HomeSectionIntroduction() {
    const { data } = useHomeData();
    const homeSectionIntroData = data?.HomeSectionIntroduction;

    return (
        <>
            <div id='homeSectionIntroWrapper'>
                <h2>{homeSectionIntroData?.title || ''}</h2>
                <p>{homeSectionIntroData?.text || ''}</p>
            </div>
        </>
    );
}

export default HomeSectionIntroduction;
